var isEmpty = function isEmpty(value) {
  var array = Array.isArray(value) ? value : Object.keys(value || {});
  return array.length === 0;
};

export default isEmpty;